__turbopack_context__.v({
  "applyAspectRatio": "S6DdoW_applyAspectRatio",
});
